import React from 'react';
import { SearchIcon } from 'lucide-react';
export function Off2() {
  const handleBuildCredit = () => {
    window.open('https://go.trkrgodom.com/click', '_blank');
  };
  const handleSkip = () => {
    window.location.href = '/';
  };
  return <div className="w-full min-h-screen font-['Open_Sans'] bg-gradient-to-br from-[#e3f2fd] to-[#f3e5f5]" data-id="element-189">
      <style data-id="element-190">
        {`
          @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700;800&family=Open+Sans:wght@400;600;400italic&display=swap');
          .cta-button {
            transition: all 0.3s ease;
          }
          .cta-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
          }
          .skip-link {
            transition: all 0.2s ease;
          }
          .skip-link:hover {
            opacity: 0.8;
          }
        `}
      </style>
      <div className="px-4 py-6 min-h-screen flex flex-col items-center justify-center" data-id="element-191">
        <div className="max-w-3xl mx-auto text-center" data-id="element-192">
          {/* Main Headline */}
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-['Montserrat'] font-bold text-[#002E6D] mb-6 leading-tight" data-id="element-193">
            Ready to finally see your credit score rise? Here's the smart way to
            make it happen.
          </h1>
          {/* Subheadline */}
          <p className="text-xl md:text-2xl text-[#2E2E2E] mb-6 max-w-2xl mx-auto leading-relaxed italic font-light" data-id="element-194">
            Build real credit history while saving money — even if your score
            isn't perfect yet.
          </p>
          {/* GIF */}
          <div className="mb-6" data-id="element-195">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bheaayS4Ma6T2pNfDij7jV/KyQ8riT.png" alt="Credit Score Rising" className="w-full max-w-md mx-auto rounded-lg" data-id="element-196" />
          </div>
          {/* Info Card */}
          <div className="bg-white rounded-2xl shadow-2xl p-4 md:p-12 mb-8" data-id="element-197">
            <p className="text-xl text-[#2E2E2E] mb-8 leading-relaxed" data-id="element-198">
              The fastest way to raise your credit score is by showing
              consistent, on-time payments. That's exactly what Self helps you
              do — safely and automatically.
            </p>
            {/* CTA Button */}
            <button onClick={handleBuildCredit} className="cta-button inline-flex items-center gap-3 bg-[#0039a6] text-white text-lg md:text-xl font-semibold px-10 py-5 rounded-xl hover:bg-[#002d80] shadow-lg mb-6" data-id="element-199">
              <SearchIcon className="w-6 h-6" data-id="element-200" />
              Start Building Credit with Self
            </button>
            {/* Skip Link */}
            <div data-id="element-201">
              <button onClick={handleSkip} className="skip-link text-sm text-gray-500 hover:text-gray-700 underline" data-id="element-202">
                No thanks, I'll check later.
              </button>
            </div>
          </div>
          {/* Trust Indicators */}
          <div className="flex flex-wrap justify-center gap-6 text-gray-700 text-sm" data-id="element-203">
            <div className="flex items-center gap-2" data-id="element-204">
              <span data-id="element-205">🔒</span>
              <span data-id="element-206">100% Secure</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-207">
              <span data-id="element-208">✓</span>
              <span data-id="element-209">Trusted Partner</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-210">
              <span data-id="element-211">🎯</span>
              <span data-id="element-212">Build Credit Safely</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}